





















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import SearchProductControl from './SearchProductControl.vue';
import CategoryFacets from './facets/CategoryFacets.vue';
import scrollService from '@/core/scroll/scroll.service';
import { PageName } from '@/router/routes/constants';
import escEventService from '@/core/esc-event.service';
import { getScrollPos, setScrollPos } from './searchScrollPos.service';
import { Ensure as PageReadyForScrollEnsured } from '@/router/Ensure';
import bus from '@/core/bus';
import { HasOutstandingXhrCallsEventKey } from '@/core/http/constants';
import { Route } from 'vue-router';

let hasOutstandingXHRRequests = false;
let clearOutstandingXHRRequestsTimerHandle = 0;
export const SearchOverlayScrollPositionChanged = 'SearchOverlayScrollPositionChanged';

@Component({
    components: { SearchProductControl, CategoryFacets }
})
export default class SearchOverlay extends Vue {
    private internalShow = false;
    private scrollContainer: any = null;
    private doRestoreScrollPos = false;
    private containerScroll: number = 0;

    @Prop({ type: Boolean, default: false })
    show!: boolean;

    @Prop({ type: Boolean, default: false })
    typing!: boolean;

    @Prop({ type: HTMLElement })
    anchorElement!: HTMLElement;

    private created() {
        bus.on(HasOutstandingXhrCallsEventKey, this.handleOutstandingXhrChange);
        this.containerScroll = 0;
    }

    private handleOutstandingXhrChange(hasOutstanding: boolean) {
        if (hasOutstanding) {
            clearTimeout(clearOutstandingXHRRequestsTimerHandle);
            hasOutstandingXHRRequests = true;
        } else {
            // Allow for rendering of data returned from call
            clearOutstandingXHRRequestsTimerHandle = setTimeout(() => hasOutstandingXHRRequests = false, 25);
        }
    }

    @Watch('$route')
    onRouteChange(newRoute: Route, oldRoute: Route) {
        // Restore when returning to search-result - e.g. from product-details-page
        this.doRestoreScrollPos = oldRoute.name === PageName.PRODUCT_DETAILS;
    }

    @Watch('show', {
        immediate: true
    })
    onShowChange(show: boolean) {
        if (show) {
            // Allow element to become visible
            this.internalShow = true;
            this.$nextTick(() => {
                this.scrollContainer = this.$refs.scrollContainer;
                scrollService.disableBodyScroll(this.scrollContainer);
                if (this.doRestoreScrollPos) {
                    this.restoreScrollPos();
                }
                this.scrollContainer.addEventListener('scroll', this.captureScrollPos);
                escEventService.register(this.close);
            });
        } else if (this.internalShow) {
            scrollService.enableBodyScroll(this.scrollContainer);
            this.scrollContainer.removeEventListener('scroll', this.captureScrollPos);
            this.internalShow = false;
        }
    }

    get scrollContainerStyle(): object {
        const top = this.anchorElement?.getBoundingClientRect().bottom ?? 0;

        return ({
            top: top + 'px'
        });
    }

    private close() {
        this.$emit('close');
    }

    private captureScrollPos(event: Event) {
        const scrollPosition = (event.target as Element).scrollTop;
        bus.emit(SearchOverlayScrollPositionChanged, scrollPosition, this.containerScroll);
        this.containerScroll = scrollPosition;
        setScrollPos(scrollPosition);
    }

    private async restoreScrollPos() {
        if (!this.doRestoreScrollPos) return;

        const savedScrollPos = getScrollPos();
        if (savedScrollPos > 0) {
            try {
                const ensure = new PageReadyForScrollEnsured(
                    () => (!hasOutstandingXHRRequests && this.scrollContainer.scrollHeight >= savedScrollPos));

                await ensure.start();
                scrollService.animateScroll(savedScrollPos, 400, this.scrollContainer);
            } catch (e) {
                // Probably timed out, we live with it.
            }
        }
    }

    $refs!: Vue['$refs'] & {
        scrollContainer: HTMLElement
    }
}
